module.exports = __webpack_public_path__ + "img/image-remove.e02839ad.png";